import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, BehaviorSubject } from 'rxjs/Rx';
import { Angulartics2 } from 'angulartics2';

import { AnalyticsService } from 'app/shared/analytics/analytics.service';
import { MathtagService } from 'app/shared/analytics/mathtag/mathtag.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { environment } from 'environments/environment';
import { FluxoVestibularService } from '../shared/fluxoVestibular.service';

import { Inscricao } from 'models/inscricao';
import { DadosPagamento } from 'models/dados-pagamento';
import { DadosVestibular } from 'models/dados-vestibular';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './pagamento.component.html',
  styleUrls: ['./pagamento.component.scss'],
  animations: [routerTransition],
})
export class PagamentoInscricaoComponent implements OnInit, OnDestroy {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  dadosVestibular: any = undefined;
  dadosVestibularSubscription: Subscription;
  dadosInscricao: Inscricao;
  formaPagamento: any = undefined;
  esconderBotaoFinalizacao = false;
  dadosPagamento: BehaviorSubject<DadosPagamento> = new BehaviorSubject<DadosPagamento>(new DadosPagamento({}));

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoVestibularService: FluxoVestibularService,
    private analytics: AnalyticsService,
    private mathtag: MathtagService,
    private angulartics2: Angulartics2,
  ) { }

  ngOnInit() {
    this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
    if(this.dadosVestibular.agendamento.valorVestibular==0){
      this.router.navigate(['/vestibular/acompanhamento']);
    }
    if (!this.dadosVestibular.vestibular) {
      this.dadosVestibularSubscription = this.fluxoVestibularService.dadosVestibularMessage$.subscribe(() => {
        this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
        this.dadosVestibularSubscription.unsubscribe();
        this.init();
      });
    } else {
      this.init();
      this.analytics.registrar(
        `Vestibular`,
        `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
        'Pagamento',
      );
    }

    // add reemarketing track
    if (environment.production === 'true' && this.dadosVestibular.vestibular.sigla === 'EA') {
      this.mathtag.inscricaoPagamento();
    }
  }

  init() {
    // init dados existentes
    if (this.dadosVestibular.pagamento && this.dadosVestibular.candidato.formaPagamento) {
      Object.assign(this, this.dadosVestibular.pagamento);
    }
    if (!this.dadosVestibular.agendamento || !this.dadosVestibular.agendamento.numeroInscricao) {
      console.error('Erro ao realizar a inscrição: número inscrição inválido');
      return;
    }
    this.dadosInscricao = Inscricao.dadosInscricaoParaInscricaoAdapter(this.dadosVestibular);
    if (this.dadosVestibular.vestibular.sigla === 'EA') {
      var campusId = this.dadosVestibular.cursoSelecionado.polo.id;
      var siglaCidade;
      switch(campusId){
        case "12": // Belém
          siglaCidade = "Belem";
          break;
        case "13": // São Luís
          siglaCidade = "SaoLuis";
          break;
        case "14": // Imperatriz
          siglaCidade = "Imperatriz";
          break;
        case "15": // Bacabal
          siglaCidade = "Bacabal";
          break;
        case "16": // Teresina
          siglaCidade = "Teresina";
          break;
        case "17": // Palmas
          siglaCidade = "Palmas";
          break;
        case "18": // Parnaíba
          siglaCidade = "Parnaiba";
          break;
      }
      this.angulartics2.eventTrack.next({
        action: `LeadVestibularPagamento-${siglaCidade}`,
      });
    }
    this.dadosPagamento.next(new DadosPagamento({
      dadosPessoais: {
        cpd: 0,
        cpf: this.dadosVestibular.candidato.cpf.replace(/\.|-/g, ''),
        numInscricao: this.dadosInscricao.inscricao.split('-')[0],
        nome: this.dadosVestibular.candidato.nome,
      },
      valorTotal: this.dadosInscricao.valorBoleto,
      valorDesconto: typeof this.dadosInscricao.parcelamentoSelected === undefined ? this.dadosInscricao.parcelamentoSelected.desconto.valor:null,
      sistema: {
        codigoSistema: environment.codigoSistemaVestibular,
        nomeSistema: 'VESTIBULAR',
        servico: {
          codigo: 12,
          descricao: 'Pagamento de Vestibular',
          valorTotal: this.dadosInscricao.valorBoleto,
        },
      },
    }));
  }

  ngOnDestroy() {
    // remove script Remarketing
    if (environment.production === 'true' && this.dadosVestibular && this.dadosVestibular.vestibular.sigla === 'EA') {
      this.mathtag.removerTodosScripts();
    }
  }

  onPagamentoSucesso(formaPagamento) {
    this.analytics.registrar(
      `Vestibular`,
      `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
      `Pagamento via ${formaPagamento.nome}`,
    );
    this.analytics.registrar('Vestibular', 'Formas de pagamento', formaPagamento.nome);
    this.formaPagamento = formaPagamento;

    if (formaPagamento.id === 'cartao') {
      this.nextStep();
    }
  }

  onMudancaPagamento(mudancaPagamento) {
    this.esconderBotaoFinalizacao = mudancaPagamento === 'cartao';
  }

  nextStep() {
    this.fluxoVestibularService.proximoPasso({
      pagamento: {
        formaPagamento: this.formaPagamento,
      },
    });
    const proximaRota = this.fluxoVestibularService.proximaRota();
    this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });
  }
}
